/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MessagesEntityTypesExistingEntityType } from '../models/MessagesEntityTypesExistingEntityType';
import type { MessagesEntityTypesNewEntityType } from '../models/MessagesEntityTypesNewEntityType';
import type { MessagesEntityTypesUpdateEntityType } from '../models/MessagesEntityTypesUpdateEntityType';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EntityTypeApiService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Creates an entityType based on ApplicationId, name, and description. (Authorised Roles: SuperUser, ApplicationAdministrator)
     * @param requestBody Request model for creating an entityType.
     * @returns MessagesEntityTypesUpdateEntityType Created
     * @throws ApiError
     */
    public postEntityTypeApiCreateEntityType(
        requestBody?: MessagesEntityTypesNewEntityType,
    ): CancelablePromise<MessagesEntityTypesUpdateEntityType> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/rest/entitytypes/entityType',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * Updates an existing entityType based on its ID contained in the request. (Authorised Roles: SuperUser, ApplicationAdministrator)
     * @param requestBody Request DTO for updating an entityType.
     * @returns MessagesEntityTypesUpdateEntityType OK
     * @throws ApiError
     */
    public putEntityTypeApiUpdateEntityType(
        requestBody?: MessagesEntityTypesUpdateEntityType,
    ): CancelablePromise<MessagesEntityTypesUpdateEntityType> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/rest/entitytypes/entityType',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * Returns all entity types for an application
     * @param applicationId
     * @returns MessagesEntityTypesExistingEntityType OK
     * @throws ApiError
     */
    public getEntityTypeApiGetEntityTypesByApplicationId(
        applicationId: number,
    ): CancelablePromise<Array<MessagesEntityTypesExistingEntityType>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rest/entitytypes/application/{applicationId}',
            path: {
                'applicationId': applicationId,
            },
        });
    }

    /**
     *  (Authorised Roles: SuperUser, ApplicationAdministrator)
     * @param id
     * @returns void
     * @throws ApiError
     */
    public deleteEntityTypeApiDeleteEntityType(
        id: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/rest/entitytypes/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

}
